import { toNumber } from '../../../../util/util';
import { IAccountingFirm, IAccountingFirmContext, ProvisionAgreement } from '../types';

const provisionAgreementRootKey: Extract<keyof IAccountingFirm, 'provisionAgreement'> = 'provisionAgreement';
type ProvisionAgreementYearRateKey = Extract<
  keyof ProvisionAgreement,
  'firstYearRate' | 'secondYearRate' | 'thirdYearRate' | 'postThreeYearsRate'
>;

export const useProvisionAgreementForm = (context: IAccountingFirmContext) => {
  const { setProvisionAgreement, formGroup } = context;

  const handleUpdateProvisionAgreementInput = (key: keyof ProvisionAgreement, value: unknown) => {
    formGroup.setFieldValue(`${provisionAgreementRootKey}.${key}`, value);

    setProvisionAgreement((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleYearRateUpdate = (key: ProvisionAgreementYearRateKey, value: unknown) => {
    const numberValue = toNumber(value);
    handleUpdateProvisionAgreementInput(key, numberValue);
  };

  return {
    provisionAgreement: formGroup.values.provisionAgreement,
    handleUpdateProvisionAgreementInput,
    handleYearRateUpdate,
  };
};

export default useProvisionAgreementForm;
